<template>
    <v-container transparent>
        <v-layout>
            <v-card width="100%" class="px-3" flat>

                <v-toolbar flat class="py-3" color="white" :clipped="$vuetify.breakpoint.lgAndUp">
                    <template v-if="$vuetify.breakpoint.mdAndUp">
                        <v-toolbar-title class="mt-1 mr-3">Отчеты</v-toolbar-title>
                        <v-divider class="mx-2" inset vertical></v-divider>
                    </template>
                    <v-btn flat class="mt-3" @click="loadReportList()">
                        <v-icon class="notranslate">refresh</v-icon>
                        <template v-if="$vuetify.breakpoint.smAndUp">&nbsp;Обновить</template>
                    </v-btn>


                    <v-dialog v-model="utility.dialog" background="#fff" max-width="900px">
                        <template v-slot:activator="{ on }">
                            <v-btn flat color="primary" class="mt-3" v-on="on">
                                <v-icon class="notranslate">add</v-icon>
                                <template v-if="$vuetify.breakpoint.smAndUp">Зарегистрировать отчет</template>
                                <template v-else>отчет</template>
                            </v-btn>
                        </template>
                        <RegReport
                                v-on:close-dlg="utility.dialog = false"
                                v-on:reload-list="loadReportList()"
                                v-bind:report-id="editedId"
                                in-modal="true">
                        </RegReport>
                    </v-dialog>
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="utility.search"
                            append-icon="search"
                            label="Поиск"
                            single-line
                            hide-details
                            class="hidden-sm-and-down notranslate"
                    ></v-text-field>
                </v-toolbar>
                <v-toolbar flat dense class="py-3" color="white" :clipped="$vuetify.breakpoint.lgAndUp" v-if="false">
                    <template v-if="$vuetify.breakpoint.mdAndUp">
                        <div class="mt-1 mr-3">Фильтр:</div>
                    </template>
                </v-toolbar>

                <v-data-table class="py-3"
                              :headers="headers"
                              :items="reports"
                              :loading="utility.dataLoading"
                              :search="utility.search"
                              :rows-per-page-items = '[ 10, 25, 50, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]'
                              pagination.sync="{rowsPerPage:10}"
                >
                    <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <td class="text-xs-left">{{ props.item.testId }}</td>
                        <td v-if="false" class="text-xs-left">{{ props.item._id }}</td>
                        <td class="text-xs-left">{{ props.item.template }}</td>
                        <td class="text-xs-left">{{ props.item.title }}</td>
                        <td class="text-xs-left">
                            <v-btn flat small v-if="props.item.isReady" :to="'/admin/report/get/'+props.item._id+'/ru/'">
                                Открыть
                                <v-icon class="notranslate" right dark>launch</v-icon>
                            </v-btn>
                        </td>
                        <td class="text-xs-left">
                            <v-btn flat small :to="'/admin/report/combo/'+props.item.testId+'/ru/0'">
                                Combo
                                <v-icon class="notranslate" right dark>launch</v-icon>
                            </v-btn>
                        </td>

                        <td class="text-xs-left">
                            <v-btn flat small :to="'/admin/report/combo/'+props.item.testId+'/ru/1'">
                                Combo All
                                <v-icon class="notranslate" right dark>launch</v-icon>
                            </v-btn>
                        </td>

                        <td class="text-xs-left">
                            <v-icon class="notranslate" @click="editItem(props.item)">edit</v-icon>
                        </td>
                    </template>
                    <template v-slot:no-results>
                        <v-alert :value="true" color="error" icon="warning" class="notranslate">
                            По ключевым словам "{{ utility.search }}" ничего не найдено.
                        </v-alert>
                    </template>
                </v-data-table>
                <br/>

            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
    import RegReport from "./RegReport"

    export default {
        name: "RegTest",
        components: {
            RegReport
        },
        data: () => ({
            regReportFormValid: false,

            reports: [],

            editedId: "",
            utility: {
                dataLoading: true,
                search: '',
                dialog: false
            },
            rules: {
                required: value => !!value || 'Required.',
                isValidJson: value => {
                    if (!value) return false;
                    try {
                        if (JSON.parse(value)) return false;
                    }
                    catch {
                        return 'Not valid JSON.';
                    }
                    return 'Not valid JSON.';
                },
                counter: value => value.length <= 20 || 'Max 20 characters'
            }
        }),
        methods: {
            closeDialog: function () {
                this.editedId = ""
                this.utility.dialog = false
            },
            loadReportList: function () {
                var this_ = this;
                this_.utility.dataLoading = true
                this.$store.dispatch('adminReportList', {}).then(function (response) {
                    this_.response = response
                    if (this_.response.status != 200) {this_.$store.dispatch('processError', this_.response)}
                    this_.utility.dataLoading = false
                    if (this_.response.status === 200) {
                        this_.reports = this_.response.data.reports
                    }
                })
            },
            editItem(item) {
                this.editedId = item._id
                this.utility.dialog = true
            },
            filterD: (value) => {
                // eslint-disable-next-line
                console.log('filter')
                return true
                //return value==='ethnic'
            }
        },
        watch: {
            "utility.dialog": function (val) {
                if (!val) this.editedId = ""
            }
        },
        computed: {
            headers(){ return [
                {
                    text: 'Id теста',
                    align: 'left',
                    sortable: true,
                    value: 'testId'
                },
                //{text: 'Id отчета', value: '_id'},
                {text: 'Шаблон', value: 'template', filter: (value) => {
                        return value==='ethnic'
                    }},
                {text: 'Заголовок', value: 'title'},
                {text: 'Открыть', value: '_id'},
                {text: 'Комбо', value: '_id'},
                {text: 'Комбо все', value: '_id'},
                {text: 'Ред.', value: '_id'},
            ]},
        }
        ,
        created: function () {
            this.loadReportList()
        }

    }
</script>

<style type="scss" scoped>
</style>